<template>
  <v-text-field
    @input="handleVisitorEmail"
    :label="$t('appointment.formCreate.labels.visitorEmail')"
    :rules="rules"
    outlined
    :messages="messages"
  />
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'VisitorEmail',

  props: {
    rules: {
      type: Array,
    },
  },

  computed: {
    messages() {
      return this.$t('appointment.formCreate.hints.visitorEmailReportAccess')
    },
  },

  methods: {
    ...mapMutations(['setAppointmentFields']),

    handleVisitorEmail(email) {
      this.setAppointmentFields({ visitor_mail: email })
    },
  },
}
</script>
